import { useEffect, useState } from 'react';
import { ERROR_STATUS, SUCCESS_STATUS } from '../constants';
export function useGeolocation(onSuccess, onFail) {
    const [geolocation, setGeolocation] = useState(undefined);
    const [isGeolocationAvailable, setIsGeolocationAvailable] = useState(false);
    const [isRequestingGeolocation, setIsRequestingGeolocation] = useState(false);
    const onGeolocation = async () => {
        if (isGeolocationAvailable) {
            setIsRequestingGeolocation(true);
            await navigator.geolocation.getCurrentPosition((position) => {
                const { coords } = position;
                const response = {
                    latitude: coords.latitude,
                    longitude: coords.longitude,
                    status: SUCCESS_STATUS,
                };
                setGeolocation(response);
                setIsGeolocationAvailable(true);
                setIsRequestingGeolocation(false);
                onSuccess?.(response);
            }, (error) => {
                const response = {
                    status: ERROR_STATUS,
                    message: error.message,
                    errorCode: error.code,
                };
                setGeolocation(response);
                setIsRequestingGeolocation(false);
                onFail?.(response);
            });
        }
        else {
            setGeolocation(undefined);
        }
    };
    const onGetGeolocation = () => {
        if (isGeolocationAvailable) {
            onGeolocation();
        }
    };
    useEffect(() => {
        if (typeof geolocation !== undefined) {
            setIsGeolocationAvailable(true);
        }
        else {
            setIsGeolocationAvailable(false);
        }
    }, [geolocation]);
    useEffect(() => {
        if ('geolocation' in navigator) {
            setIsGeolocationAvailable(true);
        }
        else {
            // browser does not support geolocation
            setIsGeolocationAvailable(false);
        }
    }, []);
    return {
        geolocation,
        onGetGeolocation,
        isRequestingGeolocation,
        setIsRequestingGeolocation,
    };
}
